import dynamic from 'next/dynamic'
import Personalization from 'components/personalization/personalization'
import Meta from 'components/meta/meta'

const Products = dynamic(() => import('components/hits/products'))

export default function Page() {
    // Pateikite kelis atsakymus ir sistema išrinks kūrinius, kurie arčiau jūsų širdies.
    return (
        <>
            <Meta
                title="Personalizuoti pasiūlymai"
                description="Kūriniai arčiau jūsų širdies. Atraskite personalizuotus, unikalius produktus sau ir savo artimiesiems."
            />
            <Personalization reset image className="mb72" />
            <Products />
        </>
    )
}
